import React from 'react';
import _ from 'lodash';
import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../../educators/useStewardshipFilter';
import { tags_educator } from '../../../../utils/query-helpers';

export default function useUsersWhoConnectedAboutOffer(network, timestamp) {
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('user.find', {
    where: {
      eager: {
        $aggregations: _.remove([
          {
            type: 'count',
            alias: 'numberOfClaims',
            relation: 'claims',
            $where: {
              createdAt: {
                $gte: timestamp.start,
                $lte: timestamp.end
              },
              response: 'Connect'
            }
          }
        ]),
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfClaims: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
